export const CITY_INTRODUCTION = {
  en: 'The city stands at a fascinating turning point in history: the ultimate transition from a raw, medieval fortified town to an ultramodern, booming world port.',
  nl: 'De stad bevindt zich op een fascinerend kantelpunt in de geschiedenis: het is de ultieme overgangsfase van een rauwe, middeleeuwse vestingstad naar een hypermoderne, exploderende wereldhaven.',
} as const;
